module.exports = __webpack_public_path__ + "static/media/m-defend.235c2c87.pdf";